export class PropertyStatusController {
    constructor(axios) {
        this.axios = axios;
    }
    async find() {
        try {
            const response = await this.axios.get("/property-status");
            return response.data;
        }
        catch (e) {
            throw e;
        }
    }
    async detail(id) {
        try {
            const response = await this.axios.get(`/property-status/${id}`);
            return response.data;
        }
        catch (e) {
            throw e;
        }
    }
}
